import React from 'react';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import { Footer, Header } from '../Common';
// import { connect } from 'react-redux';
// import { buyerLogin } from '../../../Action/login';

class Configuration extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            minHeight: "475px"
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    updateField(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleSubmit(e) {
        // console.log('asd')
        e.preventDefault();
        let data = {

        }
        console.log(data);
        // this.props.buyerLogin(data);
    }

    render() {
        return (
            <div>
                <Header />
                <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                <div className="col-md-12 tr_blank_medium mt-5 "></div>
                <div className="container-fluid">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-4 input_name">
                                    <SideBar />
                                </div>
                                <div className="col-md-8">
                                    <div className="mt-5 mb-3 input_name big_font guide_text">
                                        Configuration
                                    </div>
                                    <div className="col-md-12" style={{ border: "1px solid #ddd", minHeight: "400px", padding: "4%" }}>
                                        <div style={{ borderBottom: "1px solid #ddd" }}>
                                            <b>account information</b>
                                        </div>
                                        <div>
                                            <div class="row conf-padding">
                                                <div className="col-md-4">User ID</div>
                                                <div className="col-md-8">1104657</div>
                                            </div>
                                            <div class="row conf-padding">
                                                <div className="col-md-4">phone number</div>
                                                <div className="col-md-8"><input className="conf-inputs" /></div>
                                            </div>
                                            <div class="row conf-padding">
                                                <div className="col-md-4">mail address</div>
                                                <div className="col-md-8"><input className="conf-inputs" /></div>
                                            </div>
                                            <div class="row conf-padding">
                                                <div className="col-md-4">password</div>
                                                <div className="col-md-8"><input className="conf-inputs" /></div>
                                            </div>
                                            <div class="row conf-padding">
                                                <div className="col-md-4">credit card</div>
                                                <div className="col-md-8"><input className="conf-inputs" /></div>
                                            </div>
                                            <div class="row conf-padding">
                                                <div className="col-md-4">Transfer account</div>
                                                <div className="col-md-8"><input className="conf-inputs" /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

// const mapStateToProps = (state) => ({
//     buyerLogin: state.buyerLogin,
// });

// BuyerLogin = connect(mapStateToProps, { buyerLogin })(BuyerLogin);

export { Configuration };